import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import LandingPage from 'pages/landingPage'
import DetailPage from './pages/detailPage/DetailPage';

function ICIntegrationApp() {
    return (
        <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route exact path="/Details/:id" component={DetailPage} />
            <Redirect exact path="/index.html" to="/" />
        </Switch>
    );
}

ICIntegrationApp.propTypes = {};

ICIntegrationApp.defaultProps = {};

export default ICIntegrationApp;